import { combineReducers } from "redux";
import tabReducers from "../slices/TabSlices";
import ftReducers from "./FamilyTreeSlices";
import cardReducers from "./CardSlices";
import auditReducers from "./AuditTrailSlice";
import documentsReducers from "./DocumentsSlice";
import permissionsReducers from "./Permissions";
export default combineReducers({
  currentCard: cardReducers,
  currentTab: tabReducers,
  familyTree: ftReducers,
  auditTrail: auditReducers,
  statusQuo: documentsReducers,
  permissions: permissionsReducers,
});
